/**************************************************
 * Nombre:       Subida
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {guardarMultiplesRegistros} from "../Modulo_Algolia/Funciones/guardarMultiplesRegistros";
import {useState} from "react";

const Subida = () => {
    const [cargando, setCargando] = useState(false);

    const subir = async () => {

        let doxProdcs = await obtenerCol('productos')
        let porductos = doxProdcs.data

        let dox = await guardarMultiplesRegistros({arrObj: porductos, col: 'productos'})


    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Button
                    loading={cargando}
                    onClick={() => subir()}
                >
                    Subir
                </Button>
            </Grid>

        </Grid>
    )

}
export default Subida